import InfoPreview from "@common/controls/InfoPreview/component";
import { type Nullable } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { useUpdated } from "@common/lib/hooks";
import { joinDefined } from "@common/lib/misc";
import { addQueryString } from "@common/lib/url";
import { Common } from "@common/types";
import React from "react";

export type PargoPickupPoint = {
  address1: string;
  address2: string;
  addressSms: string;
  businessHours: string;
  city: string;
  distance: number | null;
  latitude: number;
  longitude: number;
  pargoPointCode: string;
  phoneNumber: string | null;
  photo: string;
  photo_small?: string;
  postalcode: string;
  province: string;
  storeName: string;
  storeOwner: string;
  suburb: string;
};

export type PargoPickupAddress = Partial<Nullable<Pick<Common.Address, "postalCode" | "unit" | "street" | "city">>>;
export type PargoPickupProps = {
  address: Common.Nullable<PargoPickupAddress> | null;
  mapUrl: string;
  onPickupPointChange: (data: PargoPickupPoint) => void;
  value: PargoPickupPoint | null;
};

const PargoPickup = (props: PargoPickupProps) => {
  const i18n = useI18n();

  const [pickupPoint, setPickupPoint] = React.useState<PargoPickupPoint | null>(props.value);

  useUpdated(() => {
    setPickupPoint(pickupPoint);
  }, [props.value]);

  const mapUrl = React.useMemo(() => {
    const address = joinDefined(
      ",",
      props.address?.postalCode,
      props.address?.unit,
      props.address?.street,
      props.address?.city
    );
    return addQueryString(props.mapUrl, { address });

    // return addQueryString(props.mapUrl, { address });
  }, [props.mapUrl, props.address]);

  React.useEffect(() => {
    const onMessage = (e: MessageEvent<PargoPickupPoint>) => {
      if (!mapUrl?.startsWith(e.origin)) return;
      props.onPickupPointChange(e.data);
      setPickupPoint(e.data);
    };

    window.addEventListener("message", onMessage, false);

    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, [props.onPickupPointChange, setPickupPoint]);

  if (!mapUrl) return <div>Map url isn't set</div>;

  return (
    <div className="pargo_pickup_container">
      <iframe allow="geolocation" src={mapUrl} style={{ border: "none", width: "100%", minHeight: 400 }} />

      {!!pickupPoint ? (
        <>
          <div className="gap vertical sm" />
          <InfoPreview>
            <InfoPreview.Line
              label={i18n.location}
              value={joinDefined(", ", pickupPoint.address1, pickupPoint.address2, pickupPoint.city)}
            />
            <InfoPreview.Line label={i18n.pickupCode} value={pickupPoint.pargoPointCode} />
          </InfoPreview>
        </>
      ) : null}
    </div>
  );
};
export default PargoPickup;
